import { render } from "./ViewCompletedTraineesModal.vue?vue&type=template&id=74bcda30&scoped=true"
import script from "./ViewCompletedTraineesModal.vue?vue&type=script&lang=js"
export * from "./ViewCompletedTraineesModal.vue?vue&type=script&lang=js"

import "./ViewCompletedTraineesModal.vue?vue&type=style&index=0&id=74bcda30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bcda30"]])

export default __exports__